import { render, staticRenderFns } from "./DeviceDataTab.vue?vue&type=template&id=395ce2fd&scoped=true"
import script from "./DeviceDataTab.vue?vue&type=script&lang=ts"
export * from "./DeviceDataTab.vue?vue&type=script&lang=ts"
import style0 from "./DeviceDataTab.vue?vue&type=style&index=0&id=395ce2fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395ce2fd",
  null
  
)

export default component.exports